import { Component, OnInit, Inject, ViewChild, ElementRef, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { HistoryProvider } from '../../core/browser-providers';
import { MediaService } from '../../shared-services/media.service';
import { Http } from '@angular/http';
import { NavigationService } from '../../shared-services/navigation.service';
import { NgForm } from '@angular/forms';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { Proveedor } from './proveedor.model';
import { OperationalParametric } from '../../cliente/operationalParametric.model';
import { ApiService } from '../../core/api.service';
import { Parametric } from '../../cliente/parametric.model';

@Component({
  selector: 'app-proveedor-add-edit',
  templateUrl: './proveedor-add-edit.component.html',
  styleUrls: ['./proveedor-add-edit.component.scss']
})
export class ProveedorAddEditComponent implements OnInit {

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  @ViewChild('form') public roleForm: NgForm;

  validationFail = false;
  item: Proveedor;
  situacionesIva: Parametric[];
  messageTitle: string;
  paises: string[] = [ "ARGENTINA","CHILE"];
  isHD = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    @Inject(HistoryProvider) private history: History,
    private http: Http,
    private mediaService: MediaService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.getSituacionesIva();
    this.route.data.subscribe(data => {
      this.item = data.user;
      this.item.razonSocial = this.item.id ? this.item.razonSocial : '';
      this.item.pais = this.item.pais ? this.item.pais : '';
      this.item.cuit = this.item.cuit ? this.item.cuit : '';
      this.item.observaciones = this.item.observaciones ? this.item.observaciones : '';
      this.item.impuestoCaba = this.item.impuestoCaba ? this.item.impuestoCaba : '0';
      this.item.impuestoBsAs = this.item.impuestoBsAs ? this.item.impuestoBsAs : '0';
      this.item.observaciones = this.item.observaciones ? this.item.observaciones : '';
      this.item.situacionIva = this.item.situacionIva ? this.item.situacionIva : new OperationalParametric();
    });

    this.messageTitle = this.item.id  ? 'Edición de proveedor' : 'Alta de proveedor';

    this.mediaService.isHighDefinition.subscribe(isHD => this.isHD = isHD);
  }

  async getSituacionesIva() {
    this.situacionesIva = await this.apiService.get(Parametric, Parametric.path + 'situaciones_iva/', null).toPromise();
  }

  back() {
    this.navigationService.back();
  }

  async save() {
    if (this.validateForm()) {
      this.invokeSave();
    }
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (this.formValidatorService.isFormValid(this.roleForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.ConfirmSave();
    }

    return;
  }

  async ConfirmSave() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea guardar el proveedor ' + this.item.razonSocial + '?')
    .then( res => {
      if (res) {
        this.saveItem(res);
      }
    });
  }

  async saveItem(res) {
    if (res) {

      this.snackService.spinner(true);

    // Update
      this.item.cuit = this.item.cuit.split('-').join('');
      try {
        if (this.item.id) {
          await this.backendService.update(Proveedor.path + this.item.id, this.item);
          this.snackService.success('Proveedor editado');
          this.router.navigate(['/proveedores']);
        } else {
          await this.backendService.create(Proveedor.path, this.item);
          this.snackService.success('Proveedor creado');
          this.router.navigate(['/proveedores']);
        }
      } catch (ex) {
        if (ex[0]) {
          this.snackService.error(ex[0].details);
        } else if (ex.errors) {
          this.snackService.error(ex.errors[0].defaultMessage);
        } else {
          this.snackService.error(ex.message);
        }
      } finally {
        this.snackService.spinner(false);
      }
    }
  }
}





// WEBPACK FOOTER //
// ./src/app/productos/proveedor/proveedor-add-edit.component.ts